import {
  fetchGetUserData,
  TGetUserDataResponse,
} from '../../repositories/users/v1/get-user-data';
import { IPublicGetUserResponse } from '../../repositories/users/entities/UserDataModels/PublicGetUserResponse';
import { IApplicationContext } from '../../types/applicationContext';

export async function getUser({
  httpApi,
  logger,
}: IApplicationContext): Promise<IPublicGetUserResponse> {
  try {
    const result = (await fetchGetUserData({
      httpApi,
    })) as TGetUserDataResponse;

    return result.response;
  } catch (error) {
    if ((error as { statusCode?: number }).statusCode === 400) {
      return {};
    }

    logger.warning(error, {
      comment: '[Degradation] Нет информации о пользователе, пользователь считается неавторизованным',
    });

    return {};
  }
}
